/* Ott-common */
import { normalize } from '@dtvgo/typed-normalizr';
import { AuthType } from '@dtvgo/axios-interceptor-auth';

/* Utils */
import { PageEntity, SectionEntity } from '../../utils';

/**
 * @param {import('axios').AxiosInstance} backendAxiosInstance
 */
export default function pages(backendAxiosInstance) {
  /**
   * @typedef GetPageParams
   * @type {object}
   * @property {boolean} [entitlements]
   */
  /**
   * Gets the page using the type of the page and the region of the user account
   * @param {import('../../../../utils/constants-new').PageType} pageTypeId -
   * The type of the page to get
   * @param {GetPageParams} getPageParams - The params that should be sent as queryParams
   */
  async function getPage(pageTypeId, getPageParams = {}) {
    const response = await backendAxiosInstance.get(`/content/v1/Pages/${pageTypeId}`, {
      params: getPageParams,
      authType: AuthType.SESSION_TOKEN,
    });

    response.normalizedData = normalize({ id: pageTypeId, ...response.data.page }, PageEntity);
    return response;
  }

  /**
   * @typedef GetPageSectionParams
   * @type {object}
   * @property {number} count - Maximum number of results returned
   */
  /**
   * Gets the data for a specific section of a Page(Lander) defined in the pageID.
   * It is organized in sections, subsections and the list of Assets
   * @param {import('../../../../utils/constants').PageType} pageTypeId -
   * The type of the page to get
   * @param {string} sectionId - The id of the section to get
   * @param {GetPageSectionParams} getPageSectionParams - The params to filter the section
   */
  async function getPageSection(pageTypeId, sectionId, getPageSectionParams = {}) {
    const response = await backendAxiosInstance.get(
      `/content/v1/Pages/${pageTypeId}/sections/${sectionId}`,
      {
        includeTimeZone: true,
        includeClientType: true,
        includeEntitlements: true,
        authType: AuthType.SESSION_TOKEN,
        params: getPageSectionParams,
      },
    );

    response.normalizedData = normalize(response.data.section, SectionEntity);

    return response;
  }

  return {
    getPage,
    getPageSection,
  };
}
